import React, { useEffect, useState } from 'react';
import '../InformacionInstitucional/estilos.css';

  const InformacionFinancieraPublicada = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className="container">
       <div className="row">
          <div className="row-content">
           <div className='ldf_titulo'>
              <h2>Explicación de la Información Financiera Publicada</h2>
              <hr className='hr-gob'/>
           </div>

                   <div className="contenido-estandar">
                      <table className="table table-striped table-bordered acordeonTabla" style={{ textAlign: "center" }}>
                            <thead>
                              <tr>
                                <th colspan="2" rowspan="2">Documento</th>
                                <th>2016</th>
                                <th>2017</th>
                              </tr>
                            </thead>
                              <tbody>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td style={{ textAlign: "left" }}>Calendario del Presupuesto de Egresos del Ejercicio Fiscal</td>
                                <td>  
                                  <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/Calendario_del_presupuesto_de_Egresos_del_ejercicio_fiscal_2016.pdf" target="_blank" rel="noopener noreferrer">
                                          <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/Calendario_del_presupuesto_de_Egresos_del_ejercicio_fiscal_2017.pdf" target="_blank" rel="noopener noreferrer">
                                          <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td style={{ textAlign: "left" }}>Estructura del Calendario de Ingresos base mensual</td>
                                <td>  
                                  <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/Estructura_del_Calendario_de_Ingresos_base_mensual_2016.pdf" target="_blank" rel="noopener noreferrer">
                                          <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/Estructura_del_Calendario_de_Ingresos_base_mensual_2017.pdf" target="_blank" rel="noopener noreferrer">
                                          <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td style={{ textAlign: "left" }}>Información Adicional a la Iniciativa de la Ley de Ingresos</td>
                                <td>  
                                  <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/Informacion_adicional_a_la_iniciativa_de_la_Ley_de_Ingresos_2016.pdf" target="_blank" rel="noopener noreferrer">
                                          <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/Informacion_adicional_a_la_iniciativa_de_la_Ley_de_Ingresos_2017.pdf" target="_blank" rel="noopener noreferrer">
                                          <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                <td style={{ textAlign: "left" }}>Norma para la Difusión a la Ciudadanía de la Ley de Ingresos y del Presupuesto de Egresos</td>
                                <td>  
                                  <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/Norma_para_la_difusion_a_la_ciudadania_de_la_Ley_de_Ingresos_y_del_Presupuesto_de_Egresos_2016.pdf" target="_blank" rel="noopener noreferrer">
                                          <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                  </div>
                                </td>
                                <td>
                                  <div>
                                        <a href="http://dif.hidalgo.gob.mx/pdf/Norma_para_la_difusion_a_la_ciudadania_de_la_Ley_de_Ingresos_y_del_Presupuesto_de_Egresos_2017.pdf" target="_blank" rel="noopener noreferrer">
                                          <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                         </table>
                   </div>
                       
        </div>
       </div>
    </div>


    )
}

  export default InformacionFinancieraPublicada
